import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { appOverlayDisplayConfig, toolbarAndNavDisplayConfig } from '../actions';
import { OverlayDisplayConfigMessageType } from '../interface';
import { selectOverlayDisplayConfig } from '../selectors';
export function isValidOverlayMessageOrigin(inputString) {
  const regex = /(local|app|tools)(-[a-z]+[0-9])?\.(hub(spot|team)(qa)?)\.com/;
  return regex.test(inputString);
}
export function useHandleNavInappCommMessage() {
  const overlayDisplayConfigState = useAppSelector(selectOverlayDisplayConfig);
  const dispatch = useAppDispatch();
  useEffect(() => {
    const overlayOpenMessageHandler = getOverlayOpenMessageHandler(dispatch, overlayDisplayConfigState);
    const overlayCloseMessageHandler = getOverlayCloseMessageHandler(dispatch);
    window.addEventListener('message', overlayOpenMessageHandler);
    window.addEventListener('message', overlayCloseMessageHandler);
    return () => {
      window.removeEventListener('message', overlayOpenMessageHandler);
      window.removeEventListener('message', overlayCloseMessageHandler);
    };
  }, [dispatch, overlayDisplayConfigState]);
}
function getOverlayOpenMessageHandler(dispatch, existingOverlayDisplayConfig) {
  return event => {
    if (!event.data) {
      return;
    }
    if (isOverlayOpenMessage() && isValidOverlayMessageOrigin(event.origin)) {
      const {
        appName: payloadAppName
      } = event.data.payload;
      const {
        isInitialized: isOverlayDisplatStateInitialized,
        appName
      } = existingOverlayDisplayConfig;
      if (isOverlayDisplatStateInitialized && payloadAppName === appName) {
        return;
      }
      dispatch(appOverlayDisplayConfig({
        appName: event.data.payload.appName,
        [event.data.payload.overlayType]: {
          shouldShowToolbar: false,
          shouldShowNav: false
        }
      }));
      dispatch(toolbarAndNavDisplayConfig({
        isOverlayOpen: true,
        overlayType: event.data.payload.overlayType
      }));
    }
    function isOverlayOpenMessage() {
      return event.data.id === OverlayDisplayConfigMessageType.OVERLAY_OPEN_MESSAGE;
    }
  };
}
function getOverlayCloseMessageHandler(dispatch) {
  return event => {
    if (!event.data) {
      return;
    }
    if (isOverlayCloseMessage() && isValidOverlayMessageOrigin(event.origin)) {
      dispatch(toolbarAndNavDisplayConfig({
        isOverlayOpen: false
      }));
    }
    function isOverlayCloseMessage() {
      return event.data.id === OverlayDisplayConfigMessageType.OVERLAY_CLOSE_MESSAGE;
    }
  };
}